import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=0df85dad&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=ts"
export * from "./NavTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df85dad",
  null
  
)

export default component.exports